import styled, { css } from 'styled-components/macro';

import { container, containerWide } from 'styles/layout';
import { eyebrowThin, paragraph } from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const Buttons = styled.div`
  ${container}
`;

export const PillContainer = styled.div`
  ${containerWide}

  margin-top: 12px;
`;

export const NoteContainer = styled.div`
  margin: 10px 0 0;
`;

export const Timezone = styled.p`
  ${containerWide}
  ${paragraph}

  font-style: italic;
  margin: 0 auto;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;

export const Phone = styled.p`
  ${container}
  ${paragraph}

  font-style: italic;
  margin: 0 auto;

  a {
    font-weight: bold;
    text-decoration: none;
  }

  ${({ theme }: IWithThemeProps) => `
    &, a {
      color: ${theme.bottomForegroundPrimary};
    }
  `}
`;

export const AvailabilityDetailsContainer = styled.div`
  border-radius: 4px;
  margin: 18px auto;
  max-width: 446px;
  padding: 20px;
  text-align: left;

  ${({ theme }: IWithThemeProps) => css`
    background: ${theme.topBackgroundColor};
    color: ${theme.topForegroundPrimary};
  `}
`;

export const AvailabilityItem = styled.section`
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const AvailabilityHeading = styled.h3`
  ${eyebrowThin};

  margin: 0 0 2px;
`;

export const AvailabilityMessage = styled.p`
  ${paragraph};

  margin: 0;
`;
